import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const unsubscribe = async () => {
    const value = email.trim();
    if (!value || !value.includes("@")) {
      setError("Pop in the email address you want to unsubscribe");
      return;
    }
    try {
      const res = await fetch(`${API}/api/newsletter/unsubscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value }),
      });
      if (!res.ok) throw new Error();
      setDone(true);
    } catch {
      setError("Something went wrong — try again in a moment");
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF6EC] flex items-center justify-center px-4" data-testid="unsubscribe-page">
      <div className="bg-white rounded-[28px] max-w-md w-full p-8 sm:p-10 text-center shadow-sm">
        <p className="font-display text-2xl font-bold text-[#2B0B3C] mb-2">Proppa Foods</p>
        {done ? (
          <>
            <h1 className="font-display text-xl font-bold text-[#2B0B3C] mb-3" data-testid="unsubscribe-success">You're unsubscribed</h1>
            <p className="text-sm font-medium text-[#2B0B3C]/60 mb-6">
              No more emails from us — except anything about an actual order you've placed.
            </p>
          </>
        ) : (
          <>
            <h1 className="font-display text-xl font-bold text-[#2B0B3C] mb-3">Unsubscribe</h1>
            <p className="text-sm font-medium text-[#2B0B3C]/60 mb-6">
              Sorry to see you go. Confirm your email and we'll stop the marketing emails straight away.
            </p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              data-testid="unsubscribe-email-input"
              className="w-full h-12 rounded-full border border-[#2B0B3C]/15 px-5 mb-3 text-sm font-medium text-[#2B0B3C] outline-none focus:border-[#4A148C] transition-colors duration-200"
            />
            {error && <p className="text-xs font-bold text-[#C40061] mb-3" data-testid="unsubscribe-error">{error}</p>}
            <button
              onClick={unsubscribe}
              data-testid="unsubscribe-confirm-btn"
              className="w-full h-12 rounded-full bg-[#2B0B3C] text-white font-display font-bold text-sm uppercase tracking-wide hover:bg-[#FF6B00] transition-colors duration-200"
            >
              Unsubscribe me
            </button>
          </>
        )}
        <Link to="/" className="inline-block mt-6 text-xs font-bold uppercase tracking-wide text-[#4A148C] underline underline-offset-4" data-testid="unsubscribe-home-link">
          Back to proppafoods.com
        </Link>
      </div>
    </div>
  );
}
